import SearchBaseComponent from 'containers/SearchBaseComponent'
import SearchLayout from 'layout/SearchLayout'

export default function Index (props) {
  return (
    <SearchLayout>
      {() => <SearchBaseComponent {...props} />}
    </SearchLayout>
  )
}
